module.exports = {
      id: "portugal-usage",
      viewBox: "0 0 24 17",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#portugal-usage",
      toString: function () {
        return this.url;
      }
    }